import {Inject, Injectable} from 'ng-metadata/core';
import {
    getAttributesMap,
    getBackendSystem,
    getInstitutionCode,
    getResultsBulkSize
} from "../../appConfig/appConfigForward";
import {Cheetah} from "../cheetah.service";
import {MappingTablesCache} from "../../mappingTablesCache/mappingTablesCache.service";
import {CollectionDiscoveryService} from "../../collectionDiscovery/collectionDiscovery.service";
import {ResultUtil} from "../../nddUtils/resultUtil.service";

const forEach = require('lodash/forEach');
const get = require('lodash/get');

@Injectable()
export class MoreLikeThisService {
    public searchInProgress: boolean;
    public itemsSearchInProgress: boolean;
    public nextOffset: Object = {};
    public totalItems: Object = {};
    public moreLikeThisItems: Object = {};

    constructor(private collectionDiscoveryService: CollectionDiscoveryService,
                private cheetah: Cheetah,
                private resultUtil: ResultUtil,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$state') private $state: angular.ui.IStateService,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService) {

    }

    public getItemsForSameField(item: any, searchQuery ?: string, offset: number = 0): Promise<any> {
        // let institution= inst || getInstitutionCode();
        let q = "";
        let type = 'any';
        if (searchQuery === 'crs') {
            type = 'crsid';
        } else if (searchQuery === 'col') {
            type = 'cdparentid';
        }


        let args = {
            offset: offset,
            bulkSize: this.resultUtil.updatedBulkSize,
            mode: 'advanced'
            // overrideViewInstitution: institution
        };


        let moreFromSameItems: string[] = [];
        if (searchQuery === 'crs') {
            let scope = this.$stateParams['search_scope'];
            if(Array.isArray(scope)){
                if(scope.length > 0){
                    scope = scope[0];
                }else{
                    scope = 'browse_search';
                }
            }
            args.scope = scope || 'browse_search';
            if (get(item, 'pnx.search.crsid')){
                //this section builds the 'more from the same course' query from the PNX > crsid fields, but we first need to make sure these fields are belong to valid courses
                //valid course (crsinfo field) means: (no $$I OR $$I<CurrentInst>) AND no $$DDRAFT

                let crsids = get(item, 'pnx.search.crsid');
                let crsinfos = this.getDataFromCourseItem(item);
                let validCRSIDListFromCRSINFO = [];
                let crsidToPush: string = '';
                const deleteSpacesRegex: RegExp = /\s+/g;
                const removePunctuationRegex: RegExp = /[.,\/#!$%\^&\*;:{"'+<>?@|}=\-_`~()\[\]]/g;
                const deleteDoubleSpacesRegex: RegExp = /\s{2,}/g;

                if (crsinfos){
                    crsinfos.forEach(element => {   //building our valid crsids list
                        if (element.publicationStatus !== "DRAFT" && (element.courseInst===undefined || element.courseInst === getInstitutionCode())){ //Valid crsinfo: (no $$I OR $$I<CurrentInst>) AND no $$DDRAFT
                            crsidToPush=element.courseId;
                            if (crsidToPush){
                                validCRSIDListFromCRSINFO.push(crsidToPush);
                                validCRSIDListFromCRSINFO.push(crsidToPush.replace(deleteSpacesRegex, '')); //adding a crsid without spaces
                                validCRSIDListFromCRSINFO.push(crsidToPush.replace(removePunctuationRegex,' ').replace(deleteDoubleSpacesRegex,' '));//adding a crsid without punctuation
                                validCRSIDListFromCRSINFO.push(crsidToPush.replace(deleteSpacesRegex, '').replace(removePunctuationRegex,' ').replace(deleteDoubleSpacesRegex,' '))//adding a without spaces > without punctuations
                            }
                           }
                    });

                    //run on all PNX > crsid field and check if each one is in the validList. If yes, add the crsid to the 'More from the same course' queries list (moreFromSameItems)
                    crsids.forEach(element => {
                        if (validCRSIDListFromCRSINFO.indexOf(element)>-1){
                            moreFromSameItems.push(element);
                        }
                    });

                } else {
                    moreFromSameItems = get(item, 'pnx.search.crsid');
                }
            } else {
                let courses = this.getDataFromCourseItem(item);
                if (courses){
                    courses.forEach(element => {
                        if (element.publicationStatus !== "DRAFT" && (element.courseInst===undefined || element.courseInst === getInstitutionCode()))
                            moreFromSameItems.push(element.courseCodeAndSection);
                      });
                }
            }
        } else if (searchQuery === 'col') {
            args.scope = getBackendSystem() !== 'suprima' ? 'collection_discovery_search' : 'browse_search';
            if (get(item, 'pnx.search.cdparentid')){
                moreFromSameItems = get(item, 'pnx.search.cdparentid')
            } else {
                moreFromSameItems = this.getCollectionIds(item);
            }
        }

        forEach(moreFromSameItems, (crs) => {
            q += type + ',exact,' + crs + ',OR;';
        });

        args.query = q;

        if (searchQuery) {
            args.mode = 'advanced';
        }
        let res = this.cheetah.performSearch(args);
        return res;
        //return this.cheetah.performSearch(args);
    }

    public getCollectionIds(item){
        let collectionIds: string[] = [];
        let collections = this.collectionDiscoveryService.getDataFromCollectionRecord(item);
        collections.forEach(element => {
            if (element.type === "ITEM"){ //added for URM-178849
                collectionIds.push(element.collectionId);
            }
          });
        return collectionIds;
    }

    public getDataFromCourseItem(item: PrimoResponse.IDoc) : {fullCrsinfo,courseId, courseCodeAndSection, courseName, publicationStatus, courseInst}{
        let crsinfo = get(item, 'pnx.display.crsinfo');
        let courseSection = "";
        if (crsinfo) {
            return crsinfo.map((field) => {
                let dataMap;
                if (field) {
                    dataMap = {};
                    dataMap['fullCrsinfo'] = field;
                    let firstDollarSignIndex = field.indexOf("$$");
                    if (firstDollarSignIndex !== -1){ //We parse by $$ only if the crsinfo has $$ in it
                        let splittedArr = field.substring(firstDollarSignIndex).split("$$")
                        for (let s of splittedArr) {
                            let data = s.substring(1);
                            switch (s.charAt(0)) {
                                case 'R':
                                    dataMap['courseId'] = data.trimEnd();
                                    break;
                                case 'M':
                                    dataMap['courseName'] = data.trimEnd();
                                    break;
                                case 'N':
                                    courseSection = data.trimEnd();
                                    break;
                                case 'D':
                                    dataMap['publicationStatus'] = data.trimEnd();
                                    break;
                                case 'I':
                                    dataMap['courseInst'] = data.trimEnd();
                                     break;
    
                            }
                        }
                    }
                }
                dataMap['courseCodeAndSection'] = dataMap['courseId'] + '.' + courseSection;
                return dataMap;
            });
        }
    }

    public getItemFullViewParams(moreLikeThisItem) {
        if (!moreLikeThisItem) {
            return undefined;
        }
        let params = angular.copy(this.$location.search());
        if (getBackendSystem() === 'suprima' && this.$state.current.name === 'servicesPage') {
            params['rft.mms_id'] = get(moreLikeThisItem, 'pnx.control.recordid', '').toString().replace('alma', '');
            params.rft_dat = 'ie=';
            params.ie = undefined;
        } else {
            params.docid = get(moreLikeThisItem, 'pnx.control.recordid');
        }
        return params;
    }

    public navigateToItemFullView(moreLikeThisItem) {
        let params = this.$location.search();
        if (getBackendSystem() === 'suprima' && this.$state.current.name === 'servicesPage') {
            params['rft.mms_id'] = get(moreLikeThisItem, 'pnx.control.recordid', '').toString().replace('alma', '');
            params.rft_dat = 'ie=';
            params.ie = undefined;
            this.$state.go('servicesPage', params, {reload: true});
        } else if (getBackendSystem() === 'suprima' && (this.$state.current.name === 'jfulldisplay' || this.$state.current.name === 'exploreMain.jsearch')) {
            params.docid = get(moreLikeThisItem, 'pnx.control.recordid');
            this.$state.go('jfulldisplay', params, {reload: true});
        } else {
            params.docid = get(moreLikeThisItem, 'pnx.control.recordid');
            this.$state.go('fulldisplay', params, {reload: true});
        }
        this.$mdDialog.hide();
    }

    public getStateName() {
        switch (this.$state.current.name) {
            case 'exploreMain.search':
                return 'fulldisplay';
            case 'exploreMain.jsearch':
                return 'jfulldisplay';
            default :
                return this.$state.current.name;
        }

    }

    public parseResponse(data, item) {
        let items = get(data, 'data.docs') || get(data, 'docs');
        items = items.filter((rec) => get(item, 'pnx.control.recordid[0]') !== get(rec, 'pnx.control.recordid[0]'));
        return items;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/moreLikeThis/moreLikeThis.service.ts